<template>
  <div v-if="this.templateHtml" class="container px-0 related">
    <div class="col mt-5 mb-5">
      <h4 class="text-center" v-text="title"></h4>
      <RenderHtml :html="this.templateHtml"></RenderHtml>
    </div>
  </div>
</template>

<script>
import RenderHtml from "./render-html.vue";
export default {
  components: {
    RenderHtml,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  data: function () {
    return {
      templateHtml: null,
    };
  },
  created: function () {
    this.$http.get(this.url).then((response) => {
      if (response.data.trim() !== "") {
        this.templateHtml = response.data;
        this.initializeCarousel();
      }
    });
  },

  methods: {
    // Start the bootstrap carousel if exists
    initializeCarousel: function () {
      this.$nextTick(() => {
        $(".related .carousel").carousel();
      });
    },
  },
};
</script>
